import { fetchApi, getUserId } from 'shared/functions';

export const getLoggedUserService = async () => {
  const userId = getUserId();

  const { data } = await fetchApi(`/sso/users/${userId}`).then(res => res.json());

  return data;
};
